var Xhr = /** @class */ (function () {
    function Xhr() {
    }
    /*public getJSON(url, successHandler, errorHandler) {
     let xhr = new XMLHttpRequest();
     xhr.open('get', url, true);
     xhr.responseType = 'json';
     xhr.onload = function () {
     let status = xhr.status;
     if (status == 200) {
     successHandler && successHandler(xhr.response); // jshint ignore:line
     } else {
     errorHandler && errorHandler(status); // jshint ignore:line
     }
     };
     xhr.send()
     }*/
    // jshint ignore:start
    Xhr.prototype.getJSON = function (url, successHandler, errorHandler) {
        var xhr = typeof XMLHttpRequest != 'undefined'
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('get', url, true);
        xhr.onreadystatechange = function () {
            var status;
            var data;
            // https://xhr.spec.whatwg.org/#dom-xmlhttprequest-readystate
            if (xhr.readyState == 4) { // `DONE`
                status = xhr.status;
                if (status == 200) {
                    data = JSON.parse(xhr.responseText);
                    successHandler && successHandler(data);
                }
                else {
                    errorHandler && errorHandler(status);
                }
            }
        };
        xhr.send();
    };
    ;
    Xhr.prototype.sendJson = function (url, data, successHandler, errorHandler) {
        var xhr = typeof XMLHttpRequest != 'undefined'
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('post', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            var status;
            if (xhr.readyState == 4) { // `DONE`
                status = xhr.status;
                if (status == 200) {
                    successHandler && successHandler(JSON.parse(xhr.responseText));
                }
                else {
                    errorHandler && errorHandler(JSON.parse(xhr.responseText));
                }
            }
        };
        xhr.send(JSON.stringify(data));
    };
    ;
    return Xhr;
}());
//# sourceMappingURL=xhr.js.map